import InitialsAvatar from "./initials-avatar";

export default function UserAvatar({ user, width, ...props}) {
  return (
    <>
      <div className="rounded-circle overflow-hidden" style={{width:width, height:width}}>
        {user.photo ?
            <div className={"d-flex align-items-center align-content-center img-fit-wrap"} style={{width:width, height:width}}>
                <img
                    src={user.photo}
                    alt={user?.name}
                    title={user?.name}
                    className="img-fit"/>
                <span className="d-none">{user?.name}</span>
            </div>
            : <InitialsAvatar user={user} width={width} {...props} />
      }
    </div>
</>
)
    ;
}
